import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['Uczysz chemii w klasach 7–8, liceum lub technikum.', 'Chcesz mieć materiały wizualne i gotowe do użycia.', 'Potrzebujesz spójnego systemu, a nie kolejnych przypadkowych kart pracy.', 'Chcesz skrócić czas przygotowania lekcji.', 'Zależy Ci na większym zaangażowaniu uczniów.'];
const notForYou = ['Szukasz kursu wideo lub formalnej certyfikacji.', 'Potrzebujesz fizycznego zestawu wysyłanego pocztą.', 'Chcesz programu tworzonego wyłącznie dla jednej szkoły.', 'Nie planujesz korzystać z materiałów cyfrowych i drukowanych.'];
export function AudienceSection() {
  return <section className="w-full bg-white/75 px-5 py-14 sm:py-20" data-id="element-24" data-mp="e0tl6ypatyit">
      <div className="mx-auto grid max-w-5xl gap-5 md:grid-cols-2 md:gap-6" data-id="element-25" data-mp="e24neu33iy7t">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-chem/20 bg-chem-soft p-6 sm:p-8" data-id="element-26" data-mp="3cq0r5xqrt9o1">
          <h3 className="mb-6 text-lg font-bold text-chem-deep sm:text-xl" data-id="element-27" data-mp="ze295f6fyy9r">
            To jest dla Ciebie, jeśli…
          </h3>
          <ul className="space-y-4" data-id="element-28" data-mp="qjxo5cdzoh25">
            {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-29" data-mp="qhbdv4zprng8">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-chem/15 text-chem-deep" data-id="element-30" data-mp="ll47jb3eo9xr">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-31" data-mp="gnb42pthlu16" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-32" data-mp="bo7viveat5og">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-rose-100 bg-rose-soft p-6 sm:p-8" data-id="element-33" data-mp="25zwhhhiy68ic">
          <h3 className="mb-6 text-lg font-bold text-ink sm:text-xl" data-id="element-34" data-mp="44p8me1xosal">
            To nie jest dla Ciebie, jeśli…
          </h3>
          <ul className="space-y-4" data-id="element-35" data-mp="3qhxha5dwkpnb">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-36" data-mp="3qign4nqa3nkz">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose-100 text-rose-600" data-id="element-37" data-mp="i3gh9ky11lrc">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-38" data-mp="n0p0zpytpxup" />
                </span>
                <span className="text-sm leading-relaxed text-ink/80" data-id="element-39" data-mp="917bf8dpegka">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}